<template>
  <div class="page-wrapper" >
    <table-list
      :columns="columns" :data="dataTable" :loading="loading" :total="total" :current="current"
      @change-page="changePage"
    ></table-list>
  </div>
</template>

<script>
  import TableList from "components/TableList/index";
  import {searchHouseList} from  'api/houseSearch'
  import ImgShow from 'components/ImgShow/index'
  export default {
    name: "HouseList",
    components:{
      TableList,
    },
    data(){
      return {
        page:1,
        current: 1,
        total: 0,
        searchData: {
          page: 1,
          limit: 10
        },
        dataTable: [],
        loading: false,
        columns:[
          {
            type:'index',
            width:60,
          },

          {
            title:'房间号',
            key:'house_name',
            align:'center'
          },
          {
            title:'房间面积',
            key:'area',
            align:'center'

          },
          {
            title:'朝向',
            key:'compartment_face_name',
            align:'center'
          },{
            title:'价格(￥/月)',
            key:'price',
            align:'center'
          },
          {
            title:'房间状态',
            key:'house_status_name',
            align:'center'
          },

        ],
        searched:null,
      }

    },
    methods:{

      findData(data){
        this.page=1;
        this.current=1;
        this.houseList(data)
      },
      houseList(data) {
        let params={
          ...data,
          page:this.page,
          limit:10
        };
        searchHouseList(params).then( res => {
          this.dataTable = res.data.rows
          this.total = res.data.total
          this.loading = false
          this.searched=params;
        })
      },

      changePage(n){
        this.current = n;
        this.page = n;
        this.houseList(this.searched)

      },
      showImg(src) {
        this.$emit('showImg', src)
      }
    },
    created(){
      this.houseTypeId = this.$route.query.houseTypeFid
      let params={
        "houseTypeId":this.houseTypeId
      }
      this.findData(params)
    }
  }
</script>

<style scoped>
  .page-wrapper{
    padding-top: 0;
  }

</style>
